import { EFonts } from 'libs/styles/styling';
import { useEffect, useRef, useState } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import styled from 'styled-components/macro';
import { useUpdateEffect } from 'usehooks-ts';

interface Props {
    id?: string;
    value?: string;
    placeholder?: string;
    width?: string;
    onChange?: (value: string) => void;
    onBlur?: (value: string) => void;
    minRows?: number;
    maxRows?: number;
    autoFocus?: boolean;
    autoSelectAll?: boolean;
    maxLength?: number;
    className?: string;
}

export const LargeTextValue = (props: Props): JSX.Element => {
    const [value, setValue] = useState<string>(props.value ?? '');
    const ref = useRef<HTMLTextAreaElement>();

    useUpdateEffect(() => {
        if (props.value !== value) {
            setValue(props.value);
        }
    }, [props.value]);

    const minRows = props.minRows ?? 5;
    const maxRows = props.maxRows ?? 5;

    useEffect(() => {
        if (ref.current && props.autoSelectAll) {
            ref.current.select();
        }
    }, [ref.current, props.autoSelectAll]);

    return (
        <S_LargeTextValue
            id={props.id}
            ref={ref}
            className={props.className}
            value={value}
            $width={props.width}
            maxLength={props.maxLength}
            autoFocus={props.autoFocus}
            placeholder={props.placeholder}
            $hasValue={value !== undefined && value !== null && value !== ''}
            autoComplete="nope"
            minRows={minRows}
            maxRows={maxRows}
            onChange={(e) => {
                setValue(e.target.value);
                props.onChange?.(e.target.value);
            }}
            onBlur={() => {
                props.onBlur?.(value);
            }}
            onKeyDown={(e) => {
                if (e.shiftKey && (e.key === 'Backspace' || e.key === 'Delete')) {
                    return;
                }
                e.stopPropagation();
            }}
        />
    );
};

const S_LargeTextValue = styled(TextareaAutosize)<{ $width: string; $hasValue: boolean }>`
    outline: none;
    border-top: none;
    border-left: none;
    border-right: none;
    line-height: 19px;
    padding: 10px 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #dadada;
    background: #f5f5f5;
    box-shadow: 0px 0px 20px 0px #dedede inset, 0px 4px 4px 0px rgba(0, 0, 0, 0.03);
    font-family: ${EFonts.Regular};
    color: #141c54;
    font-size: 12px;
    width: ${(props) => (props.$width ? props.$width : '100%')};
    resize: none;
    &:focus {
        background-color: #f5f5f5;
    }
    &::placeholder {
        color: #141c54;
    }
    &::-webkit-scrollbar,
    &::-webkit-scrollbar {
        width: 15px;
    }
    &::-webkit-scrollbar-track {
        box-shadow: '0px 0px 20px 0px #DEDEDE inset';
    }
    &::-webkit-scrollbar-thumb {
        background-color: #c5c5c5;
        border-radius: 0px;
    }
`;
